import { createSelector } from 'reselect';
import { getAdType } from '~/state/Campaign/selectors';
import { getFBAdPlacementSpec } from '~/state/AdPlacement/selectors';

export const getTargetingReady = state => state.targeting.ready;

export const getCities = state => state.targeting.cities;
export const getCustomAudiences = state => state.targeting.customAudiences;
export const getInterests = state => state.targeting.interests;

const createTargetingSpec = (cities, audiences, interests) => ({
  custom_audiences: audiences,
  geo_locations: {
    cities,
    countries: cities.length > 0 ? [] : ['US'],
    location_types: ['home', 'recent'],
  },
  flexible_spec: [{
    interests,
  }],
});

export const deriveFBTargetingSpec = createSelector(
  getCities,
  getCustomAudiences,
  getInterests,
  createTargetingSpec,
);

const combineSpecs = (targeting, fbAdPlacement) => ({ ...targeting, ...fbAdPlacement });
export const retrieveFBTargetingSpec = createSelector(
  deriveFBTargetingSpec,
  getFBAdPlacementSpec,
  combineSpecs,
);

const shouldDisplayTargeting = (targetingReady, adType) => (
  targetingReady
    && adType !== 'post_only'
);

export const getTargetingVisible = createSelector(
  getTargetingReady,
  getAdType,
  shouldDisplayTargeting,
);
